var exports = {
  "k": "x127c5a35--596394--container",
  "R": "x127c5a35--596394--preloader",
};

module.exports = exports;
